import { ENCRYPT_STORAGE, ENCRYPT_STORAGE_SESSION } from "../config/config";
import { STORE_CSP, STORE_dtoMobileSettings } from "./store-names";

export const CLEAR_STORE = async () => {
  let CSP = ENCRYPT_STORAGE.getItem(STORE_CSP);
  ENCRYPT_STORAGE.removeMultipleItems([STORE_dtoMobileSettings]);
  ENCRYPT_STORAGE_SESSION.clear();
  return CSP;
};
